export const AxiosRequestConfig = {
  /**
   * Default Base URL
   */
  baseURL: process.env.VUE_APP_API_URL,

  /**
   * Default URL
   */
  url: '/',

  /**
   * Default Method
   */
  method: 'get',

  /**
   * Access Token Variable
   */
  access_token: '',

  /**
   * Default Headers
   */
  headers: {
    'Content-Type': 'application/json',
    Accept: 'application/json'
  },

  /**
   * Default Data
   */
  data: {},

  /**
   * Default Timout
   */
  timeout: 0,

  /**
   * Default With Credentials Flag
   */
  withCredentials: true,

  /**
   * Default Response Type
   */
  responseType: 'json',

  /**
   * Default Response Encoding
   */
  responseEncoding: 'utf8',

  /**
   * Default Validate Status Method
   * @param {number} status
   */
  validateStatus(status) {
    return status >= 200 && status < 300 // default
  },

  /**
   * Default Max Redirects
   */
  maxRedirects: 5,

  /**
   * Default Socket Path
   */
  socketPath: null,

  /**
   * Default Proxy
   */
  proxy: {},

  // `transformResponse` allows changes to the response data to be made before
  // it is passed to then/catch
  transformResponse: [
    function(data) {
      // Do whatever you want to transform the data
      let recs = []

      if (data && data.errors) {
        // console.log('transformResponse errors', data.errors)
        recs = recs.concat(data)
      } else if (data && data.data && Array.isArray(data.data)) {
        // console.log('transformResponse data', data)
        // console.log('transformResponse data.data', data.data)
        data.data.forEach(d => {
          recs.push(d.attributes)
        })
      } else if (data && data.data && data.data.attributes) {
        recs = data.data.attributes
      } else {
        recs = data
      }
      // console.log('transformResponse transformed', recs)
      return recs
    }
  ]
}
